export const environment = {
  production: true,
  languageUrl: 'https://estate.dev.estatepro.de',
  baseUrl: 'https://api.estate.dev.empro.ai',
  actionApiUrl: 'https://api.action.dev.empro.ai/v1',
  permissionApiUrl: 'https://api.permissions.dev.empro.ai',
  userApiUrl: 'https://nest.api.user.dev.empro.ai/v1',
  websocketUrl: 'wss://main-estate-websocket.dev.empro.ai',
  is24RestApiUrl: 'https://rest.sandbox-immobilienscout24.de/restapi/',
  ocmUrl: 'https://api.ocm.dev.empro.ai',
  exposeAppUrl: 'https://expose.dev.empro.ai/',
  estate_online_expose_pdf: true,
  estate_online_expose_short_pdf: true,
  system_ocm_gdpr_consents_brokerage_contract: true,
  show_expose_map: true,
  dynamic_expose: true,
  show_cancellation_contract: true,
  system_brokerage_contract_cancellation_button: true,
};
